import React from "react";
import "./websiteBuilderTemplate.scss";
import classNames from "classnames";

export interface IWebsiteBuilderTemplate {
  id: number;
  src: string;
  title: string;
}

interface IWebsiteBuilderTemplateProps {
  template: IWebsiteBuilderTemplate;
  onClick?: () => void;
}

export default function WebsiteBuilderTemplate(props: IWebsiteBuilderTemplateProps) {
  const { template, onClick } = props;

  return (
    <div
      className={classNames("website-builder-template", {
        "website-builder-template-hover": onClick,
      })}
      onClick={onClick}
    >
      <img src={template?.src} alt=" " />
      <p>{template?.title}</p>
    </div>
  );
}
